import { svg } from "lit";
const icon = svg `<path d="M2.4165 16.5836V15.5003H17.5831V16.5836H2.4165ZM3.4165 14.1798V9.41699H4.99982V14.1798H3.4165ZM7.27227 14.1798V5.41699H8.85557V14.1798H7.27227ZM11.136 14.1798V7.91699H12.7193V14.1798H11.136ZM14.9998 14.1798V3.41699H16.5831V14.1798H14.9998Z" fill="currentColor"/>`;
export default icon;
